module.exports = __webpack_public_path__ + "img/irc.82e3e009.png";